import axios from '@/libs/api.request'
import Vue from 'vue'
import { sceneApi } from '@/configs/index'

export const getTableData = () => {
  return axios.request({
    url: 'get_table_data',
    method: 'get'
  })
}

export const getDragList = () => {
  return axios.request({
    url: 'get_drag_list',
    method: 'get'
  })
}

export const errorReq = () => {
  return axios.request({
    url: 'error_url',
    method: 'post'
  })
}

export const saveErrorLogger = info => {
  return new Promise((resolve, reject) => {
    Vue.http.jsonp(sceneApi + 'loginapi/1.0/sign/saveErrorLogger', { params: info }).then(res => {
      resolve(res.data.data)
    })
      .catch(err => {
        reject(err)
      })
  })
}
